import React from 'react';

import './SharedZeroState.scss';

import If from '../../Shared/If/If';

const SharedZeroState = ({ className, descriptionLine1, heading, link }) => (
  <div className={`shared-zero-state-container ${className}`}>
    <div className="shared-zero-state-heading">{heading}</div>
    <div className="shared-zero-state-description">{descriptionLine1}</div>
    <If test={link}>
      <div className="shared-zero-state-description shared-zero-state-space">
        {link}
      </div>
    </If>
  </div>
);

export default SharedZeroState;
